export const LOADING_ORGS = 'orgs/LOAD_ORGS'
export const LOADING_ORGS_SUCCESS = 'orgs/LOAD_ORGS_SUCCESS'
export const LOADING_ORGS_FAILURE = 'orgs/LOAD_ORGS_FAILURE'
